import { Link } from 'react-router-dom';

const UserLink = (props) => {
    const { firstName, lastName, userName } = props;

    return (
        <div className="mb-1 ms-2">
            <Link
                className="userlink-name"
                reloadDocument
                to={'/profile/' + userName}
            >
                {firstName} {lastName}
            </Link>
        </div>
    );
};

export default UserLink;
